import React from "react";
import { useTranslation } from "react-i18next";

export default function Loading() {
  const { t } = useTranslation();
  return (
    <div class="aoadsignloader">
      <span>{t("Sign.loading")}</span>
      <span>{t("Sign.loading")}</span>
    </div>
  );
}
